import { TranslateService } from '@ngx-translate/core';
import { Component, AfterContentInit, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { QEventsService } from 'src/app/services/events.service';
import { CasteUserService } from '@qbitartifacts/caste-client-ng';
import { InternalPermission } from '@qbitartifacts/caste-client-ng';
import { QBreadcrumbsService } from '@qbitartifacts/qbit-kit-ng';

@Component({ template: '' })
export abstract class PageBaseComponent implements AfterContentInit {
  static permissions: InternalPermission[] = [];
  abstract title: string;
  public environment = environment;

  constructor(
    public title$: Title,
    public translate$: TranslateService,
    public events: QEventsService,
    public breadcrumbs$: QBreadcrumbsService,
    public user$: CasteUserService
  ) {
    this.events
      .on('account:changed')
      .subscribe(this.onAccountChanged.bind(this));
  }

  /* istanbul ignore next */
  public onAccountChanged() {
    // This should be overriden in child class
  }

  public ngAfterContentInit() {
    // This was needed here, as TranslateLoader takes some time to have the translations available
    // NOT the best alternative, could be changed if better solution is found
    setTimeout(this.updateTitle.bind(this));
  }

  public setTitle(title: string) {
    this.title = title;
    this.updateTitle();
  }

  public updateTitle() {
    this.title$.setTitle(
      this.translate$.instant(this.title) + ' | ' + this.environment.brand.title
    );
  }

  /* istanbul ignore next */
  public updateBreadcrumb(appended: string) {
    this.breadcrumbs$.editCurrent(
      this.translate$.instant(this.title) + (appended ? ` (${appended})` : '')
    );
  }
}
